import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import type { IFAQItemData } from './types';

export const getColumnsData = ({
  setItemToOperate,
  openEditFAQModal,
  openDeleteFAQModal,
}: {
  setItemToOperate: (data: IFAQItemData | null) => void;
  openEditFAQModal: VoidFunction;
  openDeleteFAQModal: VoidFunction;
}) =>
  [
    {
      title: 'Текст вопроса',
      dataIndex: 'question',
      key: 'question',
      width: `33%`,
      ellipsis: true,
    },
    {
      title: 'Ответ на вопрос',
      dataIndex: 'answer',
      key: 'answer',
      width: `53%`,
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, question, answer, position }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, question, answer, position });
              openEditFAQModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, question, answer, position });
              openDeleteFAQModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<IFAQItemData>[];
